import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { logoLegacyDataSchema } from './data';
import { logoStylesSchemaLegacy } from './styles';

/**
 * Legacy `logo` widget envelope. Its placement is `specific` only
 * (`params.type: ['specific']` in the host model — the logo lives in a site
 * header, never in a regular column or a zero block), which needs no `type`
 * discriminator: the specific placement reuses the default shape, as it does for
 * image.
 */
export const logoLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('logo'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    data: logoLegacyDataSchema,
    styles: logoStylesSchemaLegacy,
    mobileStyles: styleBagSchema.nullish(),
});
